import { useTranslation } from "react-i18next";

import { OpenAPI } from "simplydo/interfaces";
import { Icon, Label, Table } from "simplydo/react/ui";
import { Input } from "simplydo/react/ui";

import { UserChip } from "components/lib/Chips";

type AdjustableUserListProps = {
  results: OpenAPI.Schemas["User"][];
  searchPlaceholder?: string;
  searchFunction?: (searchValue: string) => void;
  hideSearch?: boolean;
  primaryAction?: React.ReactNode;
  loading?: boolean;
  isAdmin?: (user: OpenAPI.Schemas["User"]) => boolean;
  actions: (user: OpenAPI.Schemas["User"]) => React.ReactNode;
  infoCells?: (user: OpenAPI.Schemas["User"]) => React.ReactNode;
  isGroup?: boolean;
  isTeam?: boolean;
  onClickUser?: (user: OpenAPI.Schemas["User"]) => void;
};

const AdjustableUserList = ({
  results,
  searchPlaceholder,
  searchFunction,
  hideSearch,
  primaryAction,
  loading,
  isAdmin,
  actions,
  infoCells,
  isGroup,
  isTeam,
  onClickUser,
}: AdjustableUserListProps) => {
  const { t } = useTranslation();

  return (
    <div>
      {hideSearch ? null : (
        <div
          style={{ display: "flex", flexDirection: "row", marginBottom: 10 }}
        >
          {searchFunction && (
            <Input
              style={{ flex: 1, marginRight: 5 }}
              fluid
              loading={!!loading}
              placeholder={searchPlaceholder || "Search..."}
              iconPosition="left"
              icon={loading ? "spinner" : "search"}
              onChange={(_e, { value }) => {
                searchFunction(value);
              }}
            />
          )}
          {primaryAction}
        </div>
      )}
      <Table basic="very">
        <Table.Body>
          {results.map((user) => {
            const userIsAdmin = isAdmin?.(user);
            const actionContent = actions?.(user);
            let label = "Admin";
            if (isGroup) {
              label = "Leader";
            } else if (isTeam) {
              label = `${t("common:capitalise", { key: "generic.idea" })} Owner`;
            }

            return (
              <Table.Row key={user._id} onClick={() => onClickUser?.(user)}>
                <Table.Cell>
                  <UserChip user={user} style={{ marginRight: 5 }} />
                  {userIsAdmin && (
                    <Label size="tiny" color="purple">
                      <Icon name={isTeam ? "lightbulb" : "rocket"} />
                      {label}
                    </Label>
                  )}
                </Table.Cell>
                <Table.Cell> {user.profile.tagline} </Table.Cell>
                {infoCells?.(user)}
                {actionContent && (
                  <Table.Cell textAlign="right" collapsing>
                    {actionContent}
                  </Table.Cell>
                )}
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    </div>
  );
};

export default AdjustableUserList;
